import styled, { css } from 'styled-components'
import { foldableSectionMixin } from 'builder/components/Section'

export const SectionContainer = styled.div(() => {
  return css`
    position: relative;
    ${foldableSectionMixin};
  `
})

export const SectionContent = styled.div``
